import styled from "styled-components";

export const SignUpFooter = styled.footer`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  @media only screen (min-width: 768px) and (max-width: 1199px) {
    width: 90%;
    margin: 0 auto;
  }
`;

export const FooterLogo = styled.div`
  text-align: center;
`;

export const FooterImage = styled.img`
  width: 10%;
  margin: 2% 2% 1%;
  margin-top: 20px;
`;
